import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Container, Box, TextField, Button, Typography, Paper } from "@mui/material";
import siteLogo from "../assets/rpo_logo.png";

const API_BASE = process.env.REACT_APP_API_BASE;

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    const normalizedEmail = String(email || "").trim().toLowerCase();
    if (!normalizedEmail) {
      setErrorMessage("Email is required.");
      return;
    }
    if (!isValidEmail(normalizedEmail)) {
      setErrorMessage("Enter a valid email address.");
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(`${API_BASE}/forgot-password`, {
        email: normalizedEmail,
      });

      setSuccessMessage(
        response.data?.message ||
          "If an account with that email exists, password reset instructions are ready."
      );
    } catch (err) {
      setErrorMessage(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "We couldn't start the password reset flow right now."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="md" className="login-form">
        <Paper
          elevation={3}
          sx={{ padding: 4, marginTop: 8, backgroundColor: "transparent", boxShadow: "none" }}
        >
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              border: "0",
              "& .MuiTextField-root": {
                borderRadius: "50px",
                backgroundColor: "transparent !important",
                "& .MuiOutlinedInput-notchedOutline": { border: 0 },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" },
                "& .MuiInputBase-input": { color: "black" },
                "& .MuiOutlinedInput-input::placeholder": {
                  color: "black",
                  opacity: 1,
                  paddingLeft: "15px !important",
                  paddingRight: "15px !important",
                },
              },
            }}
          >
            <img src={siteLogo} className="form-logo" alt="Logo" />
            <h1 className="text-white">Reset your password</h1>

            <div className="form-wrapper">
              <TextField
                placeholder="Email"
                variant="outlined"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />

              <Button type="submit" variant="outlined" color="primary" disabled={submitting}>
                {submitting ? "Sending..." : "Send Reset Link"}
              </Button>

              {errorMessage && <Typography color="error">{errorMessage}</Typography>}

              {successMessage && (
                <Typography sx={{ color: "white" }}>{successMessage}</Typography>
              )}


            </div>
          </Box>

          <Typography className="text-white" variant="body2" sx={{ marginTop: 2 }}>
            Back to{" "}
            <Link className="text-white" to="/login">
              Login
            </Link>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
